import { ScaleTime } from 'd3-scale';

import { OVERLAY_PADDING } from '../../../../../core/components/data-point/constants.js';
import { sanitizeZeroValues } from '../../../../../core/utils/sanitize-zero-values.js';
import { YAxisScales } from '../../../../types/state.js';
import { DatapointsMap } from '../../../../types/timeseries.js';
import { getDatapointTime } from '../../../../utils/timeseries.js';
import { getYScaleByUnit } from '../../../../utils/yAxis.js';
import { isDatapointMapBand } from '../../../types/datapoint-map-band.js';

export const getDatapointInfo = (
  currentDatapoint: DatapointsMap,
  xScale: ScaleTime<number, number>,
  yScales: YAxisScales,
) => {
  const { start, center, end, unit, cumulativeValue, value, seriesId, color } =
    currentDatapoint;

  const datapointTimestamp = getDatapointTime(start, end, center);
  const datapointXPosition = xScale(datapointTimestamp);
  const yScale = getYScaleByUnit(unit, yScales);

  if (isDatapointMapBand(currentDatapoint)) {
    return [
      {
        id: seriesId,
        color,
        x: datapointXPosition + OVERLAY_PADDING,
        y: sanitizeZeroValues(yScale, currentDatapoint.y0) + OVERLAY_PADDING,
      },
      {
        id: seriesId,
        color,
        x: datapointXPosition + OVERLAY_PADDING,
        y: sanitizeZeroValues(yScale, currentDatapoint.y1) + OVERLAY_PADDING,
      },
    ];
  }

  const y = sanitizeZeroValues(
    yScale,
    cumulativeValue ? cumulativeValue : value ?? 0,
  );
  return {
    id: seriesId,
    color,
    x: datapointXPosition + OVERLAY_PADDING,
    y: y + OVERLAY_PADDING,
  };
};
